import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import {fetchJoinHistory} from '../../../actions/joinHistory.actions';
import {fetchIdentificationWithRequestTokenOrRedirectOnFail} from '../../../actions/identification.actions';
import queryString from 'query-string';
import moment from 'moment-timezone';
import {Button, ButtonGroup, PageDescription, StepBox, Table} from '../../Common/PageComponents';
import {joinSteps} from '../../../constants/join.constans';

const stateToProps = state => {
  return {
    identification: state.identification,
    joinHistory: state.joinHistory,
  };
};

class JoinHistory extends Component {
  componentDidMount() {
    let requestParams = queryString.parse(window.location.search);
    this.props.dispatch(
      fetchIdentificationWithRequestTokenOrRedirectOnFail(
        requestParams.identityToken,
        '/member-service/join/agreement',
        this.props.history
      )
    );
  }

  _renderJoinButton() {
    if (this.props.joinHistory.length >= 30) {
      return <Button onClick={() => alert('아이디는 최대 30개까지 생성 가능합니다.')}>추가 회원 가입</Button>;
    } else if (this.props.joinHistory.length === 0) {
      this.props.history.push('/member-service/join/form');
    } else {
      return (
        <Link to="/member-service/join/form">
          <Button>추가 회원 가입</Button>
        </Link>
      );
    }
  }

  render() {
    let joinHistory = this.props.joinHistory;
    if (!joinHistory) {
      if (this.props.identification.discHash) {
        this.props.dispatch(fetchJoinHistory(this.props.identification.discHash, this.props.history));
      }
      return null;
    }

    return (
      <div>
        <StepBox steps={joinSteps} activeIndex={1} />
        <PageDescription>
          안전한 서비스이용과 개인정보보호를 위해 가입 시 실명 인증 및 본인 확인 절차를 거치고 있습니다.
          <br /> 입력하신 정보는 저장되지 않으며, 신용평가기관을 통한 실명 확인 용도로만 사용됩니다.
        </PageDescription>
        <div>
          <p className="inquiry">
            <b>{joinHistory.length}</b>개의 아이디가 검색되었습니다.
          </p>
        </div>
        <Table>
          <colgroup>
            <col style={{width: '220px'}} />
            <col style={{width: '287px'}} />
            <col style={{width: '220px'}} />
          </colgroup>
          <thead>
            <tr>
              <th>ID</th>
              <th>상호명</th>
              <th>가입일</th>
            </tr>
          </thead>
          <tbody>
            {joinHistory.map(joinHistoryItem => (
              <tr key={joinHistoryItem.userName}>
                <td>{joinHistoryItem.userName}</td>
                <td>{joinHistoryItem.pcBangName}</td>
                <td>
                  {moment
                    .utc(joinHistoryItem.created)
                    .local()
                    .format('YYYY. MM. DD')}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ButtonGroup>{this._renderJoinButton()}</ButtonGroup>
      </div>
    );
  }
}

export default withRouter(connect(stateToProps)(JoinHistory));
